import React, { useCallback, useState } from "react";
import { createContext } from "react";
import { Spin } from "antd";

export const LoadingContext = createContext();
export const LoadingContextProvider = ({ children }) => {
  const [isLoadingContext, setIsLoadingContext] = useState(false);

  const startLoading = useCallback(() => {
    setIsLoadingContext(true);
  }, []);

  const stopLoading = useCallback(() => {
    setIsLoadingContext(false);
  }, []);

  return (
    <LoadingContext.Provider value={{ startLoading, stopLoading, isLoadingContext }}>
      <Spin spinning={isLoadingContext} size="large">
        {children}
      </Spin>
    </LoadingContext.Provider>
  );
};
